module.exports = __webpack_public_path__ + "img/pad_thai.4eb2bb76.jpg";